import { graphql } from "babel-plugin-relay/macro";

export const generateChatIdeasMutation = graphql`
  mutation chatIdeasMutation(
    $chatId: String
    $question: String
    $deckId: String!
    $mode: AssistantMode!
    $withTranslation: Boolean
  ) {
    generateChatIdeas(
      chatId: $chatId
      question: $question
      deckId: $deckId
      mode: $mode
      withTranslation: $withTranslation
    ) {
      idea
      ideaTranslation
      tags
    }
  }
`;
